




import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';
import dataProxy from "@/services/data-proxy.service";
import {ServisnaOperacija} from "@/services/BackendProxies";
import {State} from "vuex-class";

@Component({})
export default class ServisneOperacijeEditor extends Vue {
    @State servisneOperacije!: { id: string, grupaDelovaVozilaId: number }[];
    @Prop() value!: string;
    @Prop() parent!: string;

    model = '';

    async created() {
        this.model = this.value;
    }

    @Watch('value') onValueChange(value) {
        this.model = value;
    }

    @Watch('model') onModelChange(value) {
        this.input(value);
    }

    @Emit() input(value) {
        const grupaDelova = this.servisneOperacije.find(x => x.id == value);
        this.grupaDelova(grupaDelova ? [grupaDelova.grupaDelovaVozilaId].filter(x => x != null) : []);
    }

    @Emit() grupaDelova(value) {
    }

}
